import loadable from '@loadable/component';
import {loadableAuthParams} from '@components/Skeleton/loadableParams';

const AllbryCounsellor = {
  AccountSelection: loadable(() => import('./AccountSelection'), loadableAuthParams),
};

export default AllbryCounsellor;
